(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Keep the native disclosure state in sync after Horizon resets the drawer.
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.open && details.classList.contains('menu-drawer-container') && details.closest('.kb-quiet-drawer') && matchMedia('(max-width:749px)').matches) {
    details.querySelector(':scope > summary')?.focus({ preventScroll: true });
  }
  if (details.classList.contains('kb-quiet-accordion')) {
    details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
